
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col } from "react-bootstrap";

import ConsultaGrupoProduto from '../../../../../lib/json/consultas/GrupoProduto.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import SubmitForm from "../../../../components/SubmitForm";
import { ErroMsg, SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import TitlePageTotvs from "../../../../components/TitlePageTotvs";
import { ConsultaTotvsEmpresa } from "../../../../../backend/ConsultaTotvsEmpresa";
import SelectFixo from "../../../../components/SelectFixo";
import SelectComprador from "../../../../components/Select/Comprador";
import SelectContaContabil from "../../../../components/Select/ContaContabil";

function FichaGrupoProduto(){
    const navigate = useNavigate();
    const isFormVisual = window.location.href.includes('Visualizar');
    
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);

    const { idGrupoProduto, empresaFilialCompras } = useParams();
    
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialCompras);
    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialCompras);

    // Consulta do grid
    var consultaDefault  = ConsultaGrupoProduto.consulta + (idGrupoProduto ? ` WHERE BM_GRUPO = '${idGrupoProduto}'` : '');

    const [campoCodigo, setCampoCodigo]       = useState('0');
    const [campoDescricao, setCampoDescricao] = useState('');
    const [campoComprador, setCampoComprador] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorAVL, setCampoCompradorAVL] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorCON, setCampoCompradorCON] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorLOC, setCampoCompradorLOC] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorSER, setCampoCompradorSER] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorEPI, setCampoCompradorEPI] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorREV, setCampoCompradorREV] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorATV, setCampoCompradorATV] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorBRN, setCampoCompradorBRN] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorIEX, setCampoCompradorIEX] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorISB, setCampoCompradorISB] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoCompradorIMN, setCampoCompradorIMN] = useState({value: '', label: 'Selecione o Comprador'});
    const [campoObgValor, setCampoObgValor] = useState({value: 'N', text: 'Não'});
    const [campoTipoGrupo, setCampoTipoGrupo] = useState({value: '0001', text: 'Consumível'});
    const [campoCTAVLO, setCampoCTAVLO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTAVLC, setCampoCTAVLC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTCONO, setCampoCTCONO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTCONC, setCampoCTCONC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTLOCO, setCampoCTLOCO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTLOCC, setCampoCTLOCC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTSERO, setCampoCTSERO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTSERC, setCampoCTSERC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTEPIO, setCampoCTEPIO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTEPIC, setCampoCTEPIC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTREVO, setCampoCTREVO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTREVC, setCampoCTREVC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTATVO, setCampoCTATVO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTATVC, setCampoCTATVC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTBRNO, setCampoCTBRNO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTBRNC, setCampoCTBRNC] = useState({value: '', label: 'Selecione a Conta Contábil'});    
    const [campoCTIEXO, setCampoCTIEXO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTIEXC, setCampoCTIEXC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTISBO, setCampoCTISBO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTISBC, setCampoCTISBC] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTIMNO, setCampoCTIMNO] = useState({value: '', label: 'Selecione a Conta Contábil'});
    const [campoCTIMNC, setCampoCTIMNC] = useState({value: '', label: 'Selecione a Conta Contábil'});

    useEffect(() => {
        if (idGrupoProduto){
            loadGrupoProduto();
        }
    }, []);

    // Processa consulta do grid
    const loadGrupoProduto = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaGrupoProduto.tabelas, empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) );
        
        if (retConsulta.data){
            let option = retConsulta.data[0].BM_XVLOBR === 'S' ? 'Sim' : 'Não'
            let optionTipo = retConsulta.data[0].BM_XVLOBR === '0001' ? 'Consumível' : retConsulta.data[0].BM_XVLOBR === '0002' ? 'EPI' : retConsulta.data[0].BM_XVLOBR === '0003' ? "Equipamento" : ""

            setCampoCodigo(retConsulta.data[0].BM_GRUPO);
            setCampoDescricao(retConsulta.data[0].BM_DESC);
            setCampoComprador({value: retConsulta.data[0].Y1_USER.trim(), label: retConsulta.data[0].BM_XCOMDEF.trim() ? retConsulta.data[0].BM_XCOMDEF + ' - ' + retConsulta.data[0].Y1_NOME : 'Selecione o Comprador'});
            setCampoCompradorAVL({value: retConsulta.data[0].BM_XCOM001, label: retConsulta.data[0].BM_XCOM001.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorCON({value: retConsulta.data[0].BM_XCOM002, label: retConsulta.data[0].BM_XCOM002.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorLOC({value: retConsulta.data[0].BM_XCOM003, label: retConsulta.data[0].BM_XCOM003.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorSER({value: retConsulta.data[0].BM_XCOM004, label: retConsulta.data[0].BM_XCOM004.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorEPI({value: retConsulta.data[0].BM_XCOM005, label: retConsulta.data[0].BM_XCOM005.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorREV({value: retConsulta.data[0].BM_XCOM006, label: retConsulta.data[0].BM_XCOM006.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorATV({value: retConsulta.data[0].BM_XCOM007, label: retConsulta.data[0].BM_XCOM007.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorBRN({value: retConsulta.data[0].BM_XCOM008, label: retConsulta.data[0].BM_XCOM008.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorIEX({value: retConsulta.data[0].BM_XCOM009, label: retConsulta.data[0].BM_XCOM009.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorISB({value: retConsulta.data[0].BM_XCOM010, label: retConsulta.data[0].BM_XCOM010.trim() ? '' : 'Selecione o Comprador'});
            setCampoCompradorIMN({value: retConsulta.data[0].BM_XCOM011, label: retConsulta.data[0].BM_XCOM011.trim() ? '' : 'Selecione o Comprador'});
            setCampoTipoGrupo({value: retConsulta.data[0].BM_XGRUPO.trim(), text: optionTipo});
            setCampoObgValor({value: retConsulta.data[0].BM_XVLOBR.trim(), text: option});
            setCampoCTAVLO({value: retConsulta.data[0].BM_XCTAVLO, label: ''});
            setCampoCTAVLC({value: retConsulta.data[0].BM_XCTAVLC, label: ''});
            setCampoCTCONO({value: retConsulta.data[0].BM_XCTCONO, label: ''});
            setCampoCTCONC({value: retConsulta.data[0].BM_XCTCONC, label: ''});
            setCampoCTLOCO({value: retConsulta.data[0].BM_XCTLOCO, label: ''});
            setCampoCTLOCC({value: retConsulta.data[0].BM_XCTLOCC, label: ''});
            setCampoCTSERO({value: retConsulta.data[0].BM_XCTSERO, label: ''});
            setCampoCTSERC({value: retConsulta.data[0].BM_XCTSERC, label: ''});
            setCampoCTEPIO({value: retConsulta.data[0].BM_XCTEPIO, label: ''});
            setCampoCTEPIC({value: retConsulta.data[0].BM_XCTEPIC, label: ''});
            setCampoCTREVO({value: retConsulta.data[0].BM_XCTREVO, label: ''});
            setCampoCTREVC({value: retConsulta.data[0].BM_XCTREVC, label: ''});
            setCampoCTATVO({value: retConsulta.data[0].BM_XCTATVO, label: ''});
            setCampoCTATVC({value: retConsulta.data[0].BM_XCTATVC, label: ''});
            setCampoCTBRNO({value: retConsulta.data[0].BM_XCTBRNO, label: ''});
            setCampoCTBRNC({value: retConsulta.data[0].BM_XCTBRNC, label: ''});            
            setCampoCTIEXO({value: retConsulta.data[0].BM_XCTIEXO, label: ''});
            setCampoCTIEXC({value: retConsulta.data[0].BM_XCTIEXC, label: ''});
            setCampoCTISBO({value: retConsulta.data[0].BM_XCTISBO, label: ''});
            setCampoCTISBC({value: retConsulta.data[0].BM_XCTISBC, label: ''});
            setCampoCTIMNO({value: retConsulta.data[0].BM_XCTIMNO, label: ''});
            setCampoCTIMNC({value: retConsulta.data[0].BM_XCTIMNC, label: ''});
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        // Verificar se todos os campos obrigatórios foram preenchidos
        if (!campoDescricao) {
            toast.warning('O prenchimento do campo é obrigatório.');
            return;
        }

        const cJSON = { 
            ACAO: idGrupoProduto ? 'INCLUIR' : 'ALTERAR',
            BM_GRUPO: campoCodigo,
            BM_DESC: campoDescricao,
            BM_XCOMDEF: ( campoComprador.label && campoComprador.label.trim() ? campoComprador.label.split(' - ')[0] : ''),
            BM_XCOM001: ( campoCompradorAVL?.value && campoCompradorAVL?.label.trim() ? campoCompradorAVL.value : '' ),
            BM_XCOM002: ( campoCompradorCON?.value && campoCompradorCON?.label.trim() ? campoCompradorCON.value : '' ),
            BM_XCOM003: ( campoCompradorLOC?.value && campoCompradorLOC?.label.trim() ? campoCompradorLOC.value : '' ),
            BM_XCOM004: ( campoCompradorSER?.value && campoCompradorSER?.label.trim() ? campoCompradorSER.value : '' ),
            BM_XCOM005: ( campoCompradorEPI?.value && campoCompradorEPI?.label.trim() ? campoCompradorEPI.value : '' ),
            BM_XCOM006: ( campoCompradorREV?.value && campoCompradorREV?.label.trim() ? campoCompradorREV.value : '' ),
            BM_XCOM007: ( campoCompradorATV?.value && campoCompradorATV?.label.trim() ? campoCompradorATV.value : '' ),
            BM_XCOM008: ( campoCompradorBRN?.value && campoCompradorBRN?.label.trim() ? campoCompradorBRN.value : '' ),
            BM_XCOM009: ( campoCompradorIEX?.value && campoCompradorIEX?.label.trim() ? campoCompradorIEX.value : '' ),
            BM_XCOM010: ( campoCompradorISB?.value && campoCompradorISB?.label.trim() ? campoCompradorISB.value : '' ),
            BM_XCOM011: ( campoCompradorIMN?.value && campoCompradorIMN?.label.trim() ? campoCompradorIMN.value : '' ),
            BM_XGRUPO: campoTipoGrupo.value,
            BM_XVLOBR: campoObgValor.value,
            BM_XCTAVLO: campoCTAVLO.value,
            BM_XCTAVLC: campoCTAVLC.value,
            BM_XCTCONO: campoCTCONO.value,
            BM_XCTCONC: campoCTCONC.value,
            BM_XCTLOCO: campoCTLOCO.value,
            BM_XCTLOCC: campoCTLOCC.value,
            BM_XCTSERO: campoCTSERO.value,
            BM_XCTSERC: campoCTSERC.value,
            BM_XCTEPIO: campoCTEPIO.value,
            BM_XCTEPIC: campoCTEPIC.value,
            BM_XCTREVO: campoCTREVO.value,
            BM_XCTREVC: campoCTREVC.value,
            BM_XCTATVO: campoCTATVO.value,
            BM_XCTATVC: campoCTATVC.value,
            BM_XCTBRNO: campoCTBRNO.value,
            BM_XCTBRNC: campoCTBRNC.value,
            BM_XCTIEXO: campoCTIEXO.value,
            BM_XCTIEXC: campoCTIEXC.value,
            BM_XCTISBO: campoCTISBO.value,
            BM_XCTISBC: campoCTISBC.value,
            BM_XCTIMNO: campoCTIMNO.value,
            BM_XCTIMNC: campoCTIMNC.value
        }

        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('GRUPOPRODUTO', cJSON, empresaFilial)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
        }
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Grupo de Produto" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial &&
                <>
                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral 
                                label="Código"
                                tipo='text'
                                value={campoCodigo}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoCodigo(e.target.value)}
                                disabled={!idGrupoProduto || disabledForm }                    
                            />
                        </Col>

                        <Col md="10" xs="12">
                            <InputGeral 
                                label="Descrição"
                                tipo='text'
                                value={campoDescricao}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoDescricao(e.target.value)}
                                disabled={!idGrupoProduto ||disabledForm}
                            />
                        </Col>

                        <Col md="4" xs="12">
                            <SelectFixo 
                                options={[
                                    {
                                        value: '0001',
                                        text: "Consumível",
                                    },
                                    {
                                        value: '0002',
                                        text: "EPI",
                                    },
                                    {
                                        value: '0003',
                                        text: "Equipamento",
                                    }
                                ]}
                                value={campoTipoGrupo} 
                                selectedOptionValue={campoTipoGrupo} 
                                isLabel={true} 
                                label="Tipo Grupo" 
                                onChange={(e) => setCampoTipoGrupo(e)}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoComprador={campoComprador}
                                changeComprador={setCampoComprador}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectFixo 
                                options={[{
                                    value: 'S',
                                    text: "Sim",
                                },
                                {
                                    value: 'N',
                                    text: "Não",
                                }]}
                                value={campoObgValor} 
                                selectedOptionValue={campoObgValor} 
                                isLabel={true} 
                                label="Obrigatório Valor SC" 
                                onChange={(e) => setCampoObgValor(e)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Conta Contábil - Configuração: </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Aplicativo: </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTAVLO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTAVLO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTAVLC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTAVLC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorAVL}
                                changeComprador={setCampoCompradorAVL}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Consumo: </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTCONO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTCONO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTCONC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTCONC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorCON}
                                changeComprador={setCampoCompradorCON}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Locações: </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTLOCO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTLOCO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTLOCC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTLOCC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorLOC}
                                changeComprador={setCampoCompradorLOC}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Serviços: </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTSERO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTSERO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTSERC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTSERC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorSER}
                                changeComprador={setCampoCompradorSER}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>EPI: </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTEPIO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTEPIO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTEPIC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTEPIC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorEPI}
                                changeComprador={setCampoCompradorEPI}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Revenda: </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTREVO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTREVO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTREVC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTREVC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorREV}
                                changeComprador={setCampoCompradorREV}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Ativo: </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTATVO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTATVO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"                                
                                campoContaContabil={campoCTATVC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTATVC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorATV}
                                changeComprador={setCampoCompradorATV}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Brinde: </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTBRNO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTBRNO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTBRNC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTBRNC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorBRN}
                                changeComprador={setCampoCompradorBRN}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Indenização (Extravio): </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTIEXO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTIEXO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTIEXC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTIEXC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorIEX}
                                changeComprador={setCampoCompradorIEX}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Indenização (Substituição): </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTISBO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTISBO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTISBC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTISBC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorISB}
                                changeComprador={setCampoCompradorISB}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <h6>Indenização (Manutenção): </h6>
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Operacional"
                                campoContaContabil={campoCTIMNO}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTIMNO}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil 
                                empresaLogada={empresaFilial}
                                label="Corporativa"
                                campoContaContabil={campoCTIMNC}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoCTIMNC}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoValue="Y1_COD"
                                campoComprador={campoCompradorIMN}
                                changeComprador={setCampoCompradorIMN}
                                empresaLogada={empresaFilial}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                </>
            }
            
            <SubmitForm 
                onSave={ disabledForm ? null : handleSalvar}
                onCancel={ disabledForm ? null : "handleCancelar"}
                onVoltar={ disabledForm ? "handleVoltar" : null}
            />
        </>
    );
}

export default FichaGrupoProduto;